<template>
  <notification-data-provider v-slot="{ props, listeners }">
    <div>
      <a
        :class="{'Notification--triggerUserNotLoggedIn': props.loggedIn === false}"
        class="Notification-trigger"
        @click.prevent="listeners.openNotification"
      >
        <span class="Notification-triggerIcon">
          <span
            v-if="props.counts.totalCount > 0"
            class="fas fa-bell"
          />
          <span
            v-else
            class="far fa-bell"
          />
        </span>
        <span
          v-show="props.counts.unReadNotificationsCount > 0 || props.counts.unReadNotificationsCount === '99+'"
          class="Notification-count"
        >{{ props.counts.unReadNotificationsCount }}</span>
      </a>
      <div
        v-if="props.ui.isActive"
        class="overlay"
        @click="listeners.closeNotifications"
      />
      <svg-icons />

      <transition name="ScaleIn">
        <div
          v-if="props.ui.isActive"
          id="Notification"
          class="Notification"
          data-acc="Notification"
        >
          <div class="Notification-contentWrapper">
            <notification-filters
              :active-filter="props.ui.activeFilter"
              :saved-items-count="props.counts"
              @notification-filter:change-filter="listeners.changeFilter"
            />
            <div
              v-if="props.counts.totalCount > 0"
              class="Notification-content"
            >
              <transition-group name="list">
                <saved-item
                  v-for="item in props.filteredItems"
                  :key="item.type+item.id"
                  :item="item"
                />
              </transition-group>
            </div>
            <component
              :is="props.ui.noSavedItemFallBlack.template"
              v-if="props.ui.noSavedItemFallBlack.showFallBack"
            />
            <div
              v-if="props.loggedIn === true && props.counts.totalCount > 0"
              class="Notification-cta"
            >
              <a
                href="#"
                class="Notification-ctaClose Button Button--transparentBg"
                @click.prevent="listeners.closeNotifications"
              >
                Close
              </a>
              <a
                href="/dashboard/saved-items/saved-jobs"
                class="Button Button--primary"
              >View All</a>
            </div>
            <notification-not-logged-in v-else-if="props.loggedIn === false" />
          </div>
        </div>
      </transition>
    </div>
  </notification-data-provider>
</template>

<script>
import NotificationNoJobItem from './fallbacks/notification-no-job-item.vue';
import NotificationNoReviewItem from './fallbacks/notification-no-review-item.vue';
import NotificationNoCompanyItem from './fallbacks/notification-no-company-item.vue';
import NotificationNotLoggedIn from './fallbacks/notification-not-logged-in.vue';
import NoNotifications from './fallbacks/no-notifications.vue';
import NotificationNoRegisterInterestItem from './fallbacks/notification-no-register-interest.vue';
import SavedItem from './items/saved-item.vue';
import SvgIcons from './images/saved-items-svg.vue';
import NotificationFilters from './partials/notification-filters.vue';
import NotificationDataProvider from './notification-data-provider';

export default {
  components: {
    NotificationNotLoggedIn,
    NotificationNoReviewItem,
    NotificationNoCompanyItem,
    NoNotifications,
    NotificationNoJobItem,
    SavedItem,
    NotificationDataProvider,
    SvgIcons,
    NotificationNoRegisterInterestItem,
    NotificationFilters,
  },
};
</script>

<style scoped lang="scss">
@import "../../../scss/abstracts/abstracts";
$right: 60px !default;

.Notification-trigger{
  padding: 0 12px;
  cursor: pointer;
  display: block;

  // OVR
  position: relative;
}

.Notification-count {
  position: absolute;
  top: -6px;
  line-height: 1;
  left: 26px;
  padding: 2px 4px;
  border-radius: 6px;
  background: #FF3E3E;
  color: color('white');
  font-size: 12px;
  border: 1px solid   color($primary-color);
  font-weight: 700;
  transition: ease-in-out .3s;
  text-align: center;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
  &.Notification--countZero{
    font-size: 0;
    height: 8px;
    width: 8px;
    padding: 0;
    top: 26px;
  }
}

.Notification-triggerIcon{
  display: block;
  position: relative;
  //color: #fff;
  font-size: 1.25rem;

    // OVR

  //.Icon.Icon-bell {
  //  color: black
  //}
  }

.Notification {
  font-size: 1rem;
  position: absolute;
  top: 100%;
  margin-top: -6px;
  width: 350px;
  z-index: 15;
  // OVR
  right: 40px;
  // right: -#{$right};
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  background: #f3f3f3;
  transform-origin: top center;
  animation: 0.25s cubic-bezier(0.46, 0.03, 0.52, 0.96);

  &:before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    bottom: 100%;
    right: $right + 10px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #fff;
  }
  @media screen and (max-width: 540px) {
    max-height: calc(100vh - 60px);
    position: fixed;
    top: 54px;
    width: auto;
    left: 10px;
    right: 10px;
    &:before {
      right: $right - 5px;
    }
  }
}

.Notification-ctaClose{
  display: none;
  text-align: center;
  margin-right: 16px;
  width: 100px;
  @media screen and (max-width: 540px) {
    display: block;
  }
}

.Notification-contentWrapper{
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 600px;
  max-height: calc(100vh - 100px);
  @media screen and (max-width: 540px) {
    max-height: calc(100vh - 60px);
  }
}

.Notification-content {
  width: 100%;
  flex-grow: 1;
  max-height: calc(100% - 100px);
  overflow-y: scroll;
}

.Notification-cta {
  border-top: 1px solid #e2e2e2;
  padding: 1rem;
  text-align: center;
  align-items: center;
  background: #ffff;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  display: flex;
}

.Notification-cta {
  .Button {
    width: 100%;
    margin: 0;
  }
  .Notification-ctaClose{
    width: 160px;
    margin-right: 16px;
  }
}

.ScaleIn-enter-active,
.ScaleIn-leave-active {
  animation-name: scaleIn;
  transition: 0.2s;
}

.ScaleIn-leave-active {
  animation-direction: reverse;
}

@keyframes scaleIn {
  0% {
    opacity: 0;
    transform: scale(1, 0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  background: rgba(0, 0, 0, 0.5);
}

.ScaleIn-leave-active {
  animation-direction: reverse;
  opacity: 0;
  transform: translateX(60px) scaleY(0.5);
}

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(60px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}
</style>
